"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTypeWithOptions = exports.isType = void 0;
// @ts-ignore
const caster_1 = require("./caster");
function isType(declaration) {
    function _isType(candidate) {
        return isTypeWithOptions(declaration, {})(candidate);
    }
    return _isType;
}
exports.isType = isType;
function isTypeWithOptions(declaration, options) {
    function _isType(candidate) {
        const caster = caster_1.createCaster(declaration, options);
        const castResult = caster(candidate);
        return castResult.isValid;
    }
    return _isType;
}
exports.isTypeWithOptions = isTypeWithOptions;
